export default class Lang {
  static instance;
  constructor() {
    this.lang = {
      ro: {
        username: "Nume utilizator",
        password: "Parolă",
        login: "Autentificare",
        logout: "Delogare",
        textFieldRequired: "Acest câmp este obligatoriu",
        legalPerson: "Persoană juridică",
        naturalPerson: "Persoană fizică",
        fullName: "Nume complet",
        legalPersonName: "Denumire persoană juridică",
        naturalPersonName: "Numele și prenumele reprezentantului",
        CNP: "CNP",
        CIF: "C.I.F/C.U.I",
        phone: "Telefon",
        email: "E-mail",
        address: "Domiciliul",
        legalAddress: "Adresa sediului social",
        addressOfTheBuilding:
          "Adresa imobilului pentru care se face înscrierea",
        invalidEmail: "E-mail este invalid",
        invalidCIF: "CIF invalid",
        cnpValidation: "CNP trebuie sa inceapa cu 1, 2, 5, 6, 7 sau 8",
        numarCNP: "CNP trebuie sa contina 13 cifre",
        ziLunaCNP: "CNP-ul introdus este invalid",
        deleteItem: "Sigur vreți să ștergeți elementul?",
        errorGettingData: "Eroare la obținerea datelor",
        errorSavingData: "Eroare la salvarea datelor",
        successSaved: "Date salvate cu succes",
        errorDeletingData: "Eroare la ștergerea datelor",
        successDeleted: "Date șterge cu succes",
        deleteUser: "Ștergeți utilizatorul",
      },
      en: {
        username: "Username",
        password: "Password",
        login: "Login",
        logout: "Logout",
        textFieldRequired: "This field is required",
        legalPerson: "Legal person",
        naturalPerson: "Natural person",
        fullName: "Full name",
        CNP: "CNP",
        CIF: "VAT Reg No",
        invalidCIF: "VAT Reg No invalid",
        phone: "Phone",
        email: "Email",
        address: "Address",
        addressOfTheBuilding: "Address of the building",
        invalidEmail: "Email is not valid",
        cnpValidation: "",
        numarCNP: "",
        ziLunaCNP: "",
        deleteItem: "Do you want to delete the item?",
        errorGettingData: "Error getting data",
        errorSavingData: "Error saving data",
        successSaved: "Successfully saved data",
        errorDeletingData: "Error deleting data",
        successDeleted: "Successfully deleted data",
        deleteUser: "Delete user",
      },
    };
    this.active =
      localStorage.getItem("language") === "en" ? this.lang.en : this.lang.ro;
    this.locale = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : LocaleEnum.RO;
  }
  get(key) {
    if (!key) return "";
    if (this.active[key]) {
      return this.active[key];
    }
    for (let objKey in this.active) {
      if (objKey && objKey.toLowerCase() === key.toLowerCase()) {
        return this.active[objKey];
      }
    }
  }

  getActive() {
    return this.locale;
  }

  set(locale) {
    this.locale = locale;
    switch (locale) {
      case LocaleEnum.GB:
        this.active = this.lang.en;
        localStorage.setItem("language", LocaleEnum.GB);
        break;

      case LocaleEnum.RO:
        this.active = this.lang.ro;
        localStorage.setItem("language", LocaleEnum.RO);
        break;
      default:
        this.active = this.lang.ro;
        localStorage.setItem("language", LocaleEnum.RO);
        break;
    }
  }

  static getInstance() {
    return Lang.instance ? Lang.instance : (Lang.instance = new Lang());
  }
}

export var LocaleEnum = {
  GB: "gb",
  RO: "ro",
};

export const Languages = [
  {
    name: "English",
    shortName: "gb",
    flag: "🇺🇸",
  },
  {
    name: "Română",
    shortName: "ro",
    flag: "🇷🇴",
  },
];
